import {
  modifyLinks,
  textAlign,
  textAlignMarginLeft,
  textAlignMarginRight,
} from '../../util/DataUtil';
import {useRouter} from "next/router";

const Title = ({ title, position, emphasizedTextColor }) => {
    const { locale } = useRouter();

    return (
    <span
      className={`title ${emphasizedTextColor ? emphasizedTextColor : ''}`}
      dangerouslySetInnerHTML={{ __html: modifyLinks(title, locale) }}
      style={{
        marginLeft: textAlignMarginLeft(position),
        marginRight: textAlignMarginRight(position),
        textAlign: textAlign(position),
      }}
    />
  );
};

export default Title;
